import { isSafari } from '../../../../../../utility/browsers';

export default ({ e, el }) => {
  const cloneNode = el.cloneNode();
  cloneNode.classList.add('clone-drag-node');

  cloneNode.style.visibility = 'hidden';
  if (isSafari) {
    cloneNode.style.height = '1px';
    cloneNode.style.top = '-1000px';
    document.body.appendChild(cloneNode);
  } else {
    cloneNode.style.position = 'absolute';
    cloneNode.style.top = '-100px'; // to ensure drag doesn't carry any other element - test with 0
  }
  e.dataTransfer.setDragImage(cloneNode, 0, 0);
};
